import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { Spin, Alert } from "antd";
import { useTranslation } from "react-i18next";
// GraphQL
import GET_SURVEY_QUESTION from "graphql/queries/GetSurveyQuestion";
// Styles
import {
  Container,
  AnswersCard,
  Question,
  StyledRadio,
  CardContent,
  UpperCaseHeading,
  ContinueButton,
  ResponsiveGrid,
} from "./SingleChoiceQuestionStyle";

interface StudentAgeProps {
  onChange: (data: { age: number }) => void;
  createSurveyResponse: (surveyQuestionId: number, answerId: number) => void;
}

const StudentAge = ({ onChange, createSurveyResponse }: StudentAgeProps) => {
  const [selectedAge, setSelectedAge] = useState<number | null>(null);
  const { t } = useTranslation("registration_survey");

  // Query
  const { error, loading, data } = useQuery(GET_SURVEY_QUESTION, {
    variables: {
      order: 0,
      surveyType: 0,
    },
  });

  if (loading) return <Spin />;
  if (error) return <Alert message="Error loading question" type="error" />;

  const surveyQuestion = data?.surveyQuestion;

  if (!surveyQuestion)
    return <Alert message="Question not found" type="warning" />;

  const handleSelectionChange = (value: number) => {
    setSelectedAge(value);
  };

  const handleCardClick = (value: number) => {
    handleSelectionChange(value);
  };

  const handleSubmit = async () => {
    if (selectedAge) {
      onChange({ age: selectedAge });

      await createSurveyResponse(surveyQuestion.id, selectedAge);
    }
  };

  return (
    <Container>
      <Question>
        <UpperCaseHeading>
          {t(surveyQuestion.questionText.trim())}
        </UpperCaseHeading>
      </Question>
      <AnswersCard bodyStyle={{ padding: 0 }}>
        {surveyQuestion.surveyAnswers.map((answer: any) => (
          <ResponsiveGrid key={answer.id}>
            <CardContent
              onClick={() => handleCardClick(answer.id)}
              isSelected={selectedAge === answer.id}
            >
              <span>{t(answer.answerText.trim())}</span>
              <StyledRadio
                key={answer.id}
                value={answer.id}
                onChange={() => handleSelectionChange(answer.id)}
                checked={selectedAge === answer.id}
              />
            </CardContent>
          </ResponsiveGrid>
        ))}

        <ContinueButton
          type="primary"
          onClick={handleSubmit}
          disabled={!selectedAge}
        >
          CONTINUE
        </ContinueButton>
      </AnswersCard>
    </Container>
  );
};

export default StudentAge;
